export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Введіть новий пароль",
        "Empty": "空",
        "No data": "Немає даних",
        "Installation Package List": "Список інсталяційних пакетів",
        "Update Package": "пакет оновлення",
      
        "Settings - Profiles": "Налаштування – Профілі",
        "User Management": "Керування користувачами",
        "Operation Records": "Журнал операцій",
        "Exit": "Вийти",
        "Total pages: ": "Усього сторінок: ",
        "page": "сторінка",
        "Go to": "Перейти до ",
        "Prev": "Назад",
        "Next": "Далі",
        "per page": "Кожна сторінка",
        "items": " ",
        "Please enter the page number to go to": "请输入前往页数",
        "Language": "Мова",
        "Profile Picture": "Зображення профілю",
        "Old Password": "Старий пароль",
        "New Password": "Новий пароль",
        "Confirm Password": "Пароль для підтвердження",
        "The two passwords entered do not match": "Два введені паролі не збігаються",
        "Enter the new password again": "Введіть новий пароль ще раз.",
        "This must match the new password above": "Пароль має збігатися з введеним вище новим паролем.",
        "Invalid input。Password length must be 8–16 characters": "Неприпустиме значення. Пароль має бути завдовжки 8–16 символів",
        "Lenovo Privacy Statement": "Положення компанії Lenovo про конфіденційність",
        "Lenovo Software License Agreement": "Ліцензійна угода про програмне забезпечення Lenovo",
        "Third-Party Notice": "Повідомлення третіх осіб",
        "Third-party notifications":"Сповіщення третіх сторін",
        "Change Password": "Змінити пароль",
        "Edit Profile": "Редагувати профіль",
        "Exited successfully": "Вихід виконано успішно",
        "Admin": "Адміністратор",
        "Common user": "Звичайний користувач",
        "Super Admin":"Супер-адміністратор",
        "Model": "Модель",
        "Are you sure you want to delete this?": "Справді видалити це?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "Введіть новий пароль.Він має містити принаймні три з цих елементів: великі літери, малі літери, цифри та спеціальні символи.",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters":"Він має містити принаймні три з цих елементів: великі літери, малі літери, цифри та спеціальні символи.",
        "Tip": "Порада",
        "Confirm": "Підтвердити",
        "Cancel": "Скасувати",
        "Deletion successful": "Видалення виконано успішно",
        "Password changed successfully": "Пароль виконано успішно",
        "The file to upload is larger than 100 MB。 Please select another one。": "Розмір файлу, який потрібно вивантажити, перевищує 100 МБ. Виберіть інший.",
        "Your session has expired。 Please log in again。": "Поточний статус входу закінчився, будь ласка, увійдіть знову!",
        "Invalid network request URL": "Неправильна адреса мережевого запиту!",
        "Unknown server error": "Невідома помилка сервера!",
        "An unknown error has occurred": "Сталася невідома помилка!",
        "Request timeout。 Please check your network and try again。": "Час очікування запиту вичерпано. Перевірте мережу та повторіть спробу.",
        "Failed to connect to server": "Не вдалося підключитися до сервера",
        "Your network may be currently disconnected": "Можливо, ваша мережа зараз відключена",
        "No related device found": "Не знайдено відповідних пристроїв",
        "Pre-upgrade component not found in the device": "Компонент попереднього оновлення пристрою не знайдено",
        "FWID of the installation component not found": "Компонента встановлення FWID не знайдено",
        "Failed to set upgrade information": "Помилка оновлення налаштування інформації",
        "Failed to set specified update options": "Помилка вказання налаштувань оновлення",
        "Failed to install the update package": "Помилка встановлення пакету оновлень",
        "Failed to obtain the device handle": "Помилка отримання ручки пристрою",
        "Upgrade device mismatch": "Обновлення пристрою не відповідає",
        "Installation failed: Pre-upgrade component not found in the device": "Не вдалося встановити: компонент попереднього оновлення не знайдено на пристрої",
        "Installation failed: FWID mismatch in the component list": "Не вдалося встановити: FWID у компоненті не відповідає",
        "Installation failed: No matching monitor found for upgrade": "Не вдалося встановити: не знайдено монітора для оновлення",
        "The monitor does not exist": "Монітор не існує",
        "The command has been sent": "Команду надіслано",
        "The group does not exist": "Група не існує",
        "The command does not exist": "Команда не існує",
        "Setting does not exist": "Параметрів не існує",
        "The settings profile does not exist": "Профіль налаштувань не існує",
        "The update package does not exist": "Пакет оновлень не існує",
        "The update package record does not exist": "Запис пакета оновлень не існує",
        "Invalid password format。 It must be between 8 and 30 characters long。": "Неправильний формат пароля. Він має містити від 8 до 30 символів.",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "Поле порожнє",
        "Update time cannot be null": "Час оновлення не може бути порожнім",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "Неприпустимий час оновлення. Він не може бути раніше поточного часу або наступати більше ніж через 30 днів.",
        "Uploaded file is null": "Завантаження файлу порожнє",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "Завантаження файлу в неправильному форматі, формат файлу може бути тільки zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "Завантаження файлу в неправильному форматі, файл не може бути без суфіксу",
        "Login failed。 Make sure you entered the correct account ID and password。": "Помилка входу. Переконайтеся, що ви ввели правильний ідентифікатор облікового запису та пароль.",
        "Date": "Дата",
        "Time": "Час",
        "The data will be permanently deleted": "Ця дія назавжди видалить поточні дані, чи продовжити?",
        "Please select an item to delete first": "Будь ласка, виберіть один елемент, перш ніж видалити",
        "Select an item and then delete":"Виберіть елемент, а потім видаліть",
        "Begin Download": "Почати завантаження",
        "Start Download":"Почати завантаження",
        "Password incorrect": "Неправильний пароль",
        "Password Changed Successfully": "Успішно змінено пароль",
        "Display ID or Group ID is empty": "Ідентифікатор монітора або ідентифікатор групи порожній",
        "Select the update package": "Виберіть пакет оновлення",
        "Username already exists": "Ім'я користувача вже існує",
        "Executing monitor setting command。Please wait 10s before making new changes。": "Команда налаштування монітора виконується, зачекайте 10 секунд, перш ніж зробити нові налаштування",

        "Close": "Вимк",
        "Role does not exist。 Cannot modify role。": "олі не існує, її неможливо змінити",
        "Unknown Command": "Невідома команда",
        "Access Token Expired": "Токен доступу закінчився",
        "Invalid Refresh Token": "Неправильний знак оновлення",
        "Missing Request Parameters:": "Параметри запиту відсутні:",
        "Incorrect Request Parameter Type:": "Неправильний тип параметра запиту:",
        "Request URL Not Found:": "Запитана адреса не існує:",
        "Incorrect Request Method:": "Неправильний метод запиту:",
        "Log In": "Увійти",
        "account ID": "рахунок",
        "password": "Пароль",
        "Update failed": "Помилка оновлення",
        "Reset Password?": "Скинути пароль",
        "Logged in successfully": "Вхід виконано успішно",
        "Please contact the system administrator to reset your password": "Зверніться до системного адміністратора для скидання пароля.",
        "Retry limit exceeded。 Please try again after 30 minutes": "Спробуйте більше 5 разів, спробуйте знову через 30 хвилин.",
        "Enter the model / host name / firmware version number": "Введіть модель / ім'я хоста / номер версії мікропрограми",
        "New Group": "Нова група",
        "Delete Group": "Видалити групу",
        "Display Columns": "Показати стовпці",
        "Collapse": "Згорнути",
        "Expand": "Розгорнути",
        "Move To": "Перемістити до",
        "Export": "Експортувати",
        "Power On": "Увімкнути",
        "Power Off": "Вимкнути",
        "Screen lock": "Блокування екрана",
        "Unlock screen": "Відблокування екрана",
        "Settings": "Налаштування",
        "Export Settings Profiles": "Експорт профілів налаштувань",
        "Update": "Оновити",
        "Delete Monitor": "Видалити монітор",
        "Total devices": "Усього пристроїв",
        "Selected devices": "Вибрані пристрої",
        "Update package name": "Ім'я пакета оновлення",
        "Update Time": "Час оновлення",
        "Apply to all displays of the same model": "Застосувати на моніторах тієї ж моделі",
        "Display Settings": "Параметри дисплея",
        "Select All": "Вибрати все",
        "Settings Profiles": "Профіль налаштувань",
        "Filename": "Ім'я файлу",
        "Group": "Група",
        "Monitor Model": "Модель монітора",
        "Special ID": "Спеціальний ідентифікатор",
        "Host Name": "Ім'я хоста",
        "Host Status": "Стан хоста",
        "Monitor Status": "Стан монітора",
        "Lock Status": "Стан блокування",
        "Update Progress": "Хід оновлення",
        "Settings Profile": "Профіль налаштувань",
        "Tips": "Поради",
        "Active Time": "Активний час",
        "Overclock": "超频",
        "Operation successful": "Операцію виконано успішно",
        "Please save data": "Збережіть дані",
        "Select the data first": "Спочатку виберіть дані",
        "Cannot modify when ungrouped": "Неможливо змінити, коли не в групі",
        "Deselect All": "Скасувати вибір усіх",
        "Select the GAMMA node label value": "Виберіть значення мітки вузла GAMMA",
        "Ungrouped": "Незгруповані",
        "Offline": "Офлайн",
        "Online": "Онлайн",
        "Power on": "Запустити",
        "Power off": "Вимкнути",
        "Locked": "Заблоковано",
        "Open": "Не заблоковано",
        "Open": "Розблоковано",
        "Unlocked":"Розблоковано",
        "Not connected": "Не підключений",
        "Connected": "З' єднання",
        "Set the update start time": "Укажіть час початку оновлення",
        "Now": "Зараз",
        "Set upgrade mode": "Налаштування режиму оновлення",
        "Interactive Mode": "Інтерактивний режим",
        "Silent mode": "Беззвучний режим",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "У цьому режимі з'явиться екран оновлення мікропрограми монітора із запитом на підтвердження від користувача. Користувачі можуть двічі відкласти оновлення, після чого оновлення буде застосовано примусово.",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "In this mode, when the monitor is online, the firmware update will be automatically performed in the background. Users will not see any notifications. The update will take effect when the display is restarted. The restart of the monitor takes about a few seconds, and won't affect any ongoing tasks on your computer.",
        "Invalid input": "Неприпустиме значення",
        "Failed to log in": "Не вдалося ввійти в систему",
        "Select your preferred restart time。": "Виберіть бажаний час перезапуску залежно від використання.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "Введіть ім'я групи",
        "Apply profile:": "Застосувати профіль:",
        "A new version is available": "Доступна нова версія",
        "Restart monitor immediately after update": "Перезапустити монітор одразу після оновлення",
        "Restart when the monitor enters sleep mode": "Перезапустити монітор, коли він перейде в режим сну",
        "Restart monitor when it disconnected from all PCs": "Перезапустити, коли дисплей відключений і всі з'єднання ПК",
        "Enter the model name": "Введіть назву моделі",
        "Create Update Task": "Створити завдання оновлення",
        "Update Task List": "Оновити список завдань",
        "Cancel All": "Скасувати все",
        "View Details": "Переглянути деталі",
        "Update Details": "Деталі оновлення",
        "Update Mode": "Режим оновлення",
        "Update Creation Time": "Час створення оновлення",
        "Update Start Time": "Час початку оновлення",
        "Are you sure you want to cancel all tasks?": "Справді скасувати усі завдання?",
        "Are you sure you want to cancel this task?": "Підтвердити скасування цього завдання?",
        "Are you sure you want to delete the selected monitor?": "Справді видалити вибраний монітор?",
        "Confirm to delete all displays?": "确认要删除所有显示器吗？",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "Справді видалити це? (Неможливо видалити, коли не в групі)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Порада. Якщо параметр у параметрах дисплея неактивний, можливо, його обмежено іншим налаштуванням. Спробуйте змінити інші налаштування, щоб зняти обмеження.",
        "The WebSocket connection has been restored": "З'єднання WebSocket відновлено.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "Скопіюйте цей пароль у поле введення: ",
        "Ebook": "Електронна книга",
        "largest": "найбільший",
        "Max":"Макс.",
        "Turn off auto mode": "Вимкнути автоматичний режим",
        "Minimum": "Мінімум",
        "Restore Factory Settings": "Відновити заводські налаштування",
        "Scenario Mode": "Варіант режиму",
        "Color Gamut & Color Temperature": "Палітра кольорів і температура кольору",
        "Close PIP, PBP":"Закрити",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Neutral": "Нейтральний",
        "Panel Native": "Головна панель",
        "Neutral": "Нейтральний",
        "Neutral(7500K)":"Нейтральний",
        "Reddish(6500K)":"Теплий",
        "Bluish(9300K)":"Холодний",
        "Warm": "Теплий",
        "Cool": "Холодний",
        "Low Blue Light": "Технологія фільтрації синього кольору",
        "Custom 1": "Користувач 1",
        "Custom 2": "Користувач 2",
        "Custom 3": "Користувач 3",
        "Video Signal": "Відеосигнал",
        "Game Mode": "Режим гри",
        "Off": "Вимк",
        "Game 1": "Гра 1",
        "Game 2": "Гра 2",
        "Response Time": "Насиченість",
        "Normal": "Звичайний",
        "Extreme": "Швидкий",
        "Level 1": "Рівень 1",
        "Level 2": "Рівень 2",
        "Level 3": "Рівень 3",
        "Level 4": "Рівень 4",
        "Level 5": "Рівень 5",
        "Lan Indicator": "Індикатор LAN",
        "Linked": "Підключено",
        "No Link": "З'єднання відсутнє",
        "Blinking": "Блимає",
        "Brightness": "Контрастність",
        "Contrast": "Яскравість",
        "Smart Light": "Розумне світло",
        "Volume Control": "Регулятор гучності",
        "USB Select": "Вибір USB",
        "DP Select": "Вибір DP",
        "Aspect Ratio": "Форматне співвідношення",
        "Smart Traffic Light": "Розумний трафік світла",
        "daisy chain": "Послідовно",
        "Dynamic Contrast": "Динамічний контраст",
        "Smart Energy": "Розумна енергія",
        "Smart Audio": "Розумне аудіо",
        "Distance Warning": "Попередження про відстань",
        "Ambient Light Detection": "Виявлення навколишнього освітлення",
        "Enabled Ambient Light Detection": "Увімкнути виявлення навколишнього освітлення",
        "enabled":"enabled",
        "disabled":"disabled",
        "Waken on Touch": "Активація дотиком",
        "True Split": "Поділ екрану",
        "Face Tracking": "Відстеження обличь",
        "Audio Smart Switch": "Розумний аудіо-перемикач",
        "Auto-alarm": "Авто-попередження",
        "KVM Switch": "KVM-перемикач",
        "KVM切换": "KVM-перемикач",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "Перемикач КВМ (клавіатура, відео, миша) дозволяє двом ПК використовувати один комплект монітора, клавіатури та миші, Увімкніть одночасне перемикання відео, клавіатури та миші. Якщо вимкнено, перемикайте лише клавіатуру та мишу",
        "Sitting Reminder": "Нагадування про сидіння",
        "Gaming": "Ігри",
        "RGB Gain": "Корекція кольору",
        "Serial No": "Серійний номер",
        "Firmware Version": "Версія мікропрограми",
        "Select response time level": "Виберіть рівень терміну відгуку",
        "Enable daisy chain": "Увімкнути послідовне підключення",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "Розумний трафік світла не турбує та допомагає зменшити відволікання",
        "Enable/Disable the Audio Smart function": "Включити/Відключити функцію Розумний аудіо-перемикач",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "Функція Авто-попередження показує, чи використовується камера/мікрофон на моніторі",
        "Enable Distance Warning": "Увімкнути попередження про відстань",
        "Enable/disable face tracking": "Включити/Відключити функцію Відстеження обличь",
        "Enable Sitting Reminder": "Увімкнути нагадування про сидіння",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "Технологія Розумне аудіо дозволяє зосередитись на звуці перед собою, щоб поліпшити чіткість голосу",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "Технологія Розумна енергія автоматично управляє споживанням енергії датчиком виявлення людини",
        "Implement PBP through only one cable": "Застосовуйте функцію PBP використовуючи тільки один кабель",
        "Enable/Disable vPro technology in the monitor": "Включити/Відключити технологію vPro на моніторі",
        "Wake system by touch": "Розбудити систему дотиком",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Встановіть джерело відео та джерело USB (використовується клавіатурою та мишею) для кожного ПК",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM надає вам миттєвий доступ до двох джерел сигналу ПК натисканням двох клавіш миші",
        "Enable USB charging always on": "Зарядка через USB завжди увімкнена",
        "Select DP version": "Вибір версії DP",
        "USB Charging": "USB заряд",
        "PC": "ПК",
        "Double-click the CTRL": "Подвійний клік на клавішу CTRL",
        "Full Screen": "Повний екран",
        "Original AR": "Початкове",
        "No scaling": "Без масштабування",
        "on": "Відкрити",
        "On": "Відкрити",
        "Keyboard On": "Використати клавіатуру",
        "Mouse On": "Використати мишу",
        "Image Creation": "Створення зображення",
        "Digital Cinema": "Цифрове кіно",
        "Video Creation": "Створення відео",
        "Web Browsing": "Пошук веб-сторінок",
        "Professional Image": "Спеціальне зображення",
        "DisplayPort": "DisplayPort",
        "Auto": "Автоматично",
        "Refresh": "Оновити",
        "Search": "Шукати",
        "Record": "Запис",
        "Username": "Ім'я користувача",
        "Upload Time": "Час вивантаження",
        "Add Profiles": "Додати профілі",
        "Latest Update Package": "Останній пакет оновлень",
        "Upload Update Package": "Вивантажити пакет оновлень",
        "Upload": "Вивантажити",
        "Size": "Розмір",
        "Upload successful": "Успішно вивантажено",
        "Download successful": "Успішно завантажено",
        "Refresh successful": "Оновлення виконано успішно",
        "The upgrade package does not match the device model": "Пакет оновлення не відповідає моделі",
        "Upgrade package does not match the device model":"Пакет оновлення не відповідає моделі пристрою",
        "Please enter the setting name": "Введіть назву налаштування",
        "Edit": "Змінити",
        "Save": "Зберегти",
        "Delete": "Видалити",
        "Add": "Додати",
        "Reset Password": "Скинути пароль",
        "No": "№",
        "Full Name": "Повне ім'я",
        "Role": "Роль",
        "Creation Date": "Дата створення",
        "Operation": "Операція",
        "Actions": "Операція",
        "The user's initial password is ": "该用户的初始密码为 ",
        "The password has been reset to：": "Пароль скинуто до: ",
        "Invalid input。Usernames can only contain numbers and letters。": "Неприпустиме значення. Ім'я користувача складається з цифр і букв.",
        "Invalid input。The username must contain 4 to 30 characters。": "Неприпустиме значення. Ім'я користувача має містити від 4 до 30 символів.",
        "Installation Package": "Інсталяційний пакет",
        "Operation Date": "Дата операції",
        "Actions": "Дії",
        "Operator": "Оператор",
        "Paging component": "Paging component",
        "Quick page flipping": "Швидке перетворення сторінки",
        "Current page": "Current page",
        "Title": "Назва",
        "Details": "Деталі",
        "This is the expanded area": "This is the expanded area",
        "Set Display Column": "Встановити колонку відображення",
        "Upload file": "Завантажити файл",
        "Drop-down to expand": "Випадаючий для розширення",
        "Default": "Типовий",
        "Default Info": "Типова інформація",
        "Personal Center": "Персональний центр",
        "Personal center image button": "персональна кнопка зображення центру",
        "Expandable area": "Розширювальна площа",
        "Update Package Table": "Оновлення таблиці пакетів",
        "This is the table header": "Це заголовок таблиці",
        "This is the table content": "This is the table content",
        "UserList Table": "аблиця списку користувачів",
        "Page Up and Down": "Сторінка вгору і вниз",
        "Operation record table": "Operation record table",
        "OSD upgrade details": "Деталі оновлення OSD",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "Заряджання через USB-C",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "Спрощена китайська",
        "English": "англійська",
        "Traditional Chinese": "Традиційна китайська",
        "French": "французька",
        "German": "німецькою",
        "Italian": "Італійська",
        "Spanish": "Іспанська",
        "Japanese": "Японська",
        "Thai": "Тайська",
        "Ukrainian": "Українська",
        "Russian": "російська",
        */
        "Enter your account ID": "Введіть ідентифікатор облікового запису",
        "Please Enter your account id":"Зверніться до системного адміністратора для скидання пароля.",
        "Enter your password": "Введіть пароль",
        "Cannot exceed 20 characters": "Не може перевищувати 20 символів",
        "Enter the original password": "Введіть оригінальний пароль",
        "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ": "Ви вибрали ту саму групу, до якої пристрій належить зараз. Якщо ви хочете перемістити пристрій, виберіть іншу групу. ",
        "Enter the filename": "Введіть ім'я файлу",
        "Update Package Name": "Ім'я пакета оновлення",
        "Select the date": "Виберіть дату",
        "Select the time": "Виберіть час",
        "Set the update mode": "Установити режим оновлення",
        "Restart when the monitor is not connected to any computer": "Перезапустити монітор, коли його не буде підключено до жодного комп'ютера",
        "Invalid file format": "Неприпустимий формат файлу. Підтримуються лише файли zip/exe/dmg/app.",
        "Select a valid file type": "Виберіть дійсний тип файлу",

        "The data is being processed。 Please do not submit again。": "Дані обробляються. Не надсилайте повторно.",
        "Enter the profiles name": "Введіть ім'я профілю",
        "Enter your username": "Введіть своє ім'я користувача",
        "Enter your full name": "Введіть своє повне ім'я",
        "The initial password of this user is:": "Початковий пароль цього користувача: ",
        "Select your role": "Виберіть свою роль",
        "User Profile": "Профіль користувача",
        "Downloading": "Завантаження...",
        "Enter the new password again。Two times of new password input is same": "Введіть новий пароль ще раз.Новий пароль має збігатися з попереднім полем.",
        "Request failed with status code 502": "Запит зазнав невдачі з кодом статусу 502",

        "Please Enter your x": "Введіть {param}",
        "Select the x": "Виберіть {param}",
        "Please select the correct file type x": "Виберіть дійсний тип файлу {param}",
        "Please select the correct file type": "Виберіть дійсний тип файлу",
        "Input characters within x characters": "Не може перевищувати {param} символів",

        "Monitor List":"Список моніторів",
        "List of update packages":"Список пакетів оновлення",
        "Settings - Profiles":"Налаштування – Профілі",
        "User Management":"Керування користувачами",
       

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"Системні аномалії",

        "Upgrade Package Record ID is empty":"Виберіть пакет оновлення",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Неправильний час оновлення. Це не може бути раніше поточного часу або більше 30 днів в майбутньому.",
      
        "Request parameter is invalid:The username must contain 4 to 30 characters。":"Параметр запиту недійсний:Ім'я користувача повинно містити від 4 до 30 символів.",
        "The WebSocket connection has been lost Reconnecting":"З'єднання WebSocket було втрачено Перепідключення",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"Параметр запиту недійсний:Ім'я користувача складається з цифр і букв",

        "Request parameter is invalid:Passwordlength must be between 8-16 character":"Параметр запиту недійсний: довжина пароля повинна бути між 8-16 символами.",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"Скомпільований пакет відсутній: компонент має відповідний контейнер, який не був завантажений。 Будь ласка, завантажте його перед компіляцією.",

        "Request parameter is invalid：Password length must be 8–16 characters":"Параметр запиту недійсний: довжина пароля повинна бути між 8-16 символами",


        "Illegal request header!": "Недопустимий заголовок запиту",
        "Invalid request parameters":"Неправильні параметри запиту",
        "Export": "Експортувати",
        "It is already a high-version and there is no need to upgrade":"Це вже висока версія і немає необхідності оновлювати",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"Комунікація"
    }
}